import React, { useEffect, useMemo, useState } from 'react';
import Badge from '../../../components/uiComponent/bages';
import { debounce, trim, ceil } from 'lodash';
import { Spin, Popover, message, Tooltip, Checkbox } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import Button from '../../../components/uiComponent/button/index';
import SearchInput from '../../../components/uiComponent/inputs/searchinput';
import Pagination from '../../../components/pagination/index';
import AgGrid from '../../../components/ag-grid-table/index';
import Modal from '../../../components/uiComponent/modal/index';

import iconPurple from '../../../assets/images/box-icon-purple.svg';
import iconBlue from '../../../assets/images/box-icon-blue.svg';
import iconRed from '../../../assets/images/box-icon-red.svg';
import iconYellow from '../../../assets/images/box-icon-yellow.svg';
import iconGreen from '../../../assets/images/box-icon-green.svg';
import iconOrange from '../../../assets/images/box-icon-orange.svg';
import ProductImg from '../../../assets/images/newImages/nestle.svg';
import MarkAsResolved from '../../../assets/icons/mark-as-resolved-icon.svg';
import Receiving from '../../../assets/icons/Receiving.svg';
import InfoIcon from '../../../assets/icons/info-black.svg';
import { PoWarehouseDetailsWrapper } from './style.js';
import { BulkReceive, getWarehousePoDetails, GetWarehousePoHistory, UpdatePo } from '../../../slices/po';
import SideDrawerIcon from '../../../assets/icons/side-bar-icon.svg';
import ReceiveProductDrawer from './custom-drawer';
import ReactSelect from '../../../components/uiComponent/select/index.js';

let gridColumnApi;

const PoWarehouseDetails = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  // Modal State
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [isConfirm, setIsConfirm] = useState();
  const [revertReceivingStatus, setRevertReceivingStatus] = useState(false);
  const [bulkReceivingModal, setBulkReceivingModal] = useState(false);

  const [page, setPage] = useState({ pageSize: 25, pageNumber: 1 });
  const [filters, setFilters] = useState({ search: '', first_name: '', itemsFilter: 'viewAll' });
  const [sortBy, setSortBy] = useState({ key: '', type: '' });
  const { pageNumber, pageSize } = page || {};
  const {
    poWarehouseDetails,
    totalWarehousePoDetailsCount,
    totalOrderQuantity,
    totalReceivedQuantity,
    totalInvoiceQuantity,
    totalPoValue,
    fetchingWarehousePoDetails,
    totalSkus,
    po_status,
    po_name,
    bulkReceivingLoading
  } = useSelector((state) => state.pos || {});
  useEffect(() => {
    dispatch(getWarehousePoDetails({ page, filters, sortBy, id }));
  }, [filters]);

  const handleItemsFilter = (e) => {
    const receivedFilter = e?.target?.checked ? 'viewAll' : 'unreceived';
    setFilters(filters => ({ ...filters, itemsFilter: receivedFilter }));
    setPage(page => ({ ...page, pageNumber: 1 }));
  };

  const boxData = [
    {
      label: 'Total Invoice Qty',
      // value: totalInvoiceQuantity,
      value: Number(totalInvoiceQuantity || 0)?.toLocaleString('en-US'),
      icon: iconRed,
      className: 'box-red',
      key: 'totalUnMappedSkus'
    },
    {
      label: 'Total Received Qty',
      sortable: false,
      // value: totalReceivedQuantity,
      value: Number(totalReceivedQuantity || 0)?.toLocaleString('en-US'),
      icon: iconYellow,
      className: 'box-yellow',
      key: 'totalMappedSkus'
    }
  ];

  const handleSearchProduct = debounce((value) => {
    if (trim(value) || filters.search) {
      setPage(page => ({ ...page, pageNumber: 1 }));
      setFilters((filters) => ({ ...filters, search: value, tilesFilter: '', itemsFilter: 'viewAll' }));
    }
  }, 800);
  const columnDefs = useMemo(() => [
    {
      headerName: 'Title',
      filter: true,
      minWidth: 100,
      flex: 1,
      sortable: true,
      field: 'title',
      cellRenderer: ({ data }) => {
        return (
          <div className='card-wrapper  card-overlay-wrapper'>
            <img src={data.product?.image_url || ProductImg} className='product-image' alt='Img' title='ProductImg' />
            <Tooltip title={data.product?.name}>
              <span className='two-line-ellipsis'>
                {data.product?.name?.length > 12
                  ? `${data.product.name.substring(0, 12)}...`
                  : data.product?.name || '-'}</span>
            </Tooltip>
          </div>
        );
      }
    },
    {
      headerName: 'Identifier',
      filter: true,
      minWidth: 100,
      flex: 1,
      sortable: true,
      comparator: () => 0,
      field: 'identifier_value',
      cellRenderer: ({ data }) => (
        <div className='title-wrapper'>
          <span>{data?.product?.identifier_type?.toUpperCase() || 'N/A'}</span>
          <span className='upc-code'>{data?.product?.identifier_value || ''}</span>
        </div>
      )
    },
    {
      headerName: 'Brand',
      filter: true,
      minWidth: 100,
      flex: 1,
      field: 'brand',
      sortable: true,
      comparator: () => 0,
      cellRenderer: ({ data }) => {
        const { product } = data || {};
        const { brand = 'N/A' } = product || {};
        return (
          `${brand || 'N/A'}`
        );
      }
    },
    {
      headerName: 'Available Stock',
      sortable: false,
      filter: true,
      sortable: true,
      field: 'available_stock',
      comparator: () => 0,
      minWidth: 100,
      flex: 1,
      cellRenderer: ({ data }) => {
        const { warehouse_stock = 0, inbound_stock = 0, available_stock = 0 } = data?.product || {};
        const total = (Number(warehouse_stock) + Number(inbound_stock)) || 0;
        return (
          <div className='card-wrapper gap-1'>
            <span>
              {
                total?.toLocaleString('en-US')
              }
            </span>
            <Popover
              title={null}
              content={<InfoTooltipData data={data} />}
              placement='right'
            >
              <img src={InfoIcon} alt='InfoIcon' title='InfoIcon' />
            </Popover>
          </div>
        );
      }
    },
    {
      headerName: 'Case QTY',
      field: 'case_quantity',
      sortable: true,
      filter: true,
      minWidth: 100,
      flex: 1,
      valueFormatter: (params) => `${Number(params?.value || 0)?.toLocaleString('en-US')}`
    },
    {
      headerName: 'Invoice QTY',
      field: 'invoice_quantity',
      sortable: true,
      filter: true,
      minWidth: 100,
      comparator: () => 0,

      flex: 1,
      valueFormatter: (params) => `${Number(params?.value || 0)?.toLocaleString('en-US')}`
    },
    {
      headerName: 'Received QTY',
      field: 'received_quantity',
      sortable: true,
      filter: true,
      comparator: () => 0,

      minWidth: 100,
      flex: 1,
      valueFormatter: (params) => `${Number(params?.value || 0)?.toLocaleString('en-US')}`
    },
    {
      headerName: 'Missing Units',
      minWidth: 140,
      flex: 1,
      field: 'missing_units',
      sortable: true,
      comparator: () => 0,
      cellRenderer: ({ data }) => {
        const missingUnits = data?.missing_units || 0;
        if (po_status?.toLowerCase() === 'receiving' || po_status?.toLowerCase() === 'processed') {
          return <>{missingUnits > 0 ? missingUnits?.toLocaleString('en-US') : 0}</>;
        }

        return <>0</>;
      }
    },
    {
      headerName: 'Notes',
      field: 'notes',
      filter: true,
      minWidth: 100,
      flex: 1,
      valueFormatter: (params) => `${params.value || '-'}`,
      cellRenderer: (params) => {
        const value = params.value || '-';
        const maxLength = 25;
        const truncatedValue = value?.length > maxLength ? `${value.substring(0, maxLength)}...` : value;
        return (
          <Tooltip title={value}>
            <span>{truncatedValue}</span>
          </Tooltip>
        );
      }
    },
    {
      headerName: 'Action',

      filter: true,
      minWidth: 76,
      maxWidth: 76,
      flex: 1,
      headerClass: 'ag-center-aligned-header',
      cellClass: 'ag-center-aligned-cell',
      headerStyle: { textAlign: 'center' },
      cellRenderer: ({ data }) => (
        <div className='d-flex align-items-center justify-content-center'>
          <Tooltip title='Receiving Page'>
            <img
              className='cursor-pointer'
              src={SideDrawerIcon}
              onClick={po_status?.toLowerCase() !== 'confirmed' ? () => {
                dispatch(GetWarehousePoHistory({ po_item_id: data?.id }));
                openDrawer(data);
              } : null}
              alt='SideDrawerIcon'
              style={{
                cursor: po_status?.toLowerCase() !== 'confirmed' ? 'pointer' : 'not-allowed',
                opacity: po_status?.toLowerCase() !== 'confirmed' ? 1 : 0.5
              }}
            />
          </Tooltip>
        </div>
      )
    }
  ]);

  const defaultColDefNew = {
    resizable: true,
    sortable: false,
    filter: false,
    suppressRowClickSelection: true,
    suppressMenu: true,
    suppressMovable: true
  };

  const InfoTooltipData = ({ data }) => {
    const { warehouse_stock = 0, inbound_stock = 0 } = data?.product || {};
    return (
      <PoWarehouseDetailsWrapper className='mt-0'>
        <div className='container-box'>
          <div className='items'>
            <span>Inbound Stock</span>
            <span>{Number(inbound_stock)?.toLocaleString('en-US')}</span>
          </div>
          <div className='items'>
            <span>Warehouse Stock</span>
            <span>{Number(warehouse_stock)?.toLocaleString('en-US')}</span>
          </div>
        </div>
      </PoWarehouseDetailsWrapper>
    );
  };

  const handlePagination = (number, key) => {
    const value = Number(number);
    let newPage = {};

    if (key === 'pageSize') newPage = { pageNumber: 1, pageSize: value };
    else newPage = { ...page, pageNumber: value };

    setPage(newPage);
    dispatch(
      getWarehousePoDetails({
        page: newPage,
        filters,
        sortBy,
        id
      })
    );
  };

  const gridReady = (params) => {
    gridColumnApi = params.columnApi;
  };

  const onSortChange = (params) => {
    const value = params.columnApi.getColumnState().find((s) => s.sort != null);

    if (
      value &&
      [
        'order_quantity',
        'received_quantity',
        'unit_cost',
        'case_quantity',
        'invoice_quantity',
        'extended_cost',
        'missing_units',
        'brand',
        'title',
        'identifier_value',
        'available_stock'
      ].includes(value?.colId)
    ) {
      const { colId, sort } = value || {};
      setSortBy({ key: colId, type: sort });
      dispatch(
        getWarehousePoDetails({
          page,
          filters,
          sortBy: { key: colId, type: sort },
          id
        })
      );
    }
  };

  const refreshGridClick = () => {
    if (gridColumnApi){
      gridColumnApi.applyColumnState({
        defaultState: { sort: null },
        applyOrder: true
      });
      setSortBy({ key: '', type: '' });
    }
    dispatch(
      getWarehousePoDetails({
        page,
        filters,
        id
      })
    );
  };
  const openDrawer = (data) => {
    setSelectedData(data);
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
    setSelectedData(null);
  };

  const handlePoUpdate = (status) => {
    dispatch(UpdatePo({ poId: id, status: status })).then(() => {
      refreshGridClick();
    });
    setIsConfirm(false);
    setRevertReceivingStatus(false);
  };

  const handleBulkReceive = () => {
    dispatch(BulkReceive({ poId: id })).then(({ payload }) => {
      if (payload?.success) {
        refreshGridClick();
        setBulkReceivingModal(false);
      }
    });
  };
  return (
    <PoWarehouseDetailsWrapper>
      <div className='container-div'>
        <div className='items'>
          <label>PO Name</label>
          <p>{po_name}</p>
        </div>
        <div className='items'>
          <label>Status</label>
          <Badge circleStatus status={po_status} />
        </div>
        <div className='buttons-wrapper'>
          {
            po_status === 'Processed'
              ? <Button text='Move Back to Receiving' className={po_status?.toLowerCase() === 'confirmed' ? 'disabled-save-button' : 'map-btn-wrapper'} onClick={() => { setRevertReceivingStatus(true); }} />
              :
              <>
                <Button disabled={po_status === 'Processed' || po_status?.toLowerCase() === 'confirmed' ? true : false || poWarehouseDetails?.length === 0 } text='Bulk Receive' onClick={() => setBulkReceivingModal(true)} />
                <Button disabled={po_status === 'Processed' || po_status?.toLowerCase() === 'confirmed' ? true : false || poWarehouseDetails?.length === 0} text='Mark As Received' onClick={() => setIsConfirm(true)} />
              </>
          }
        </div>
      </div>
      <div className='box-row'>
        {boxData.map((data, ind) => (
          <div
            className={`sku-box ${filters.tilesFilter === data?.key ? 'active-box' : ''
              } ${data.className}`}
          >
            <div>
              <p>{data.label}</p>
              <h4 className='fw-bold mb-0'>{data?.value}</h4>
            </div>
            <img src={data?.icon} alt='icon' />
          </div>
        ))}
      </div>
      <div className="sub-header mb-2" style={{ display: 'flex', gap: '2rem', alignItems: 'flex-center', justifyContent: 'flex-start' }}>
        <SearchInput
          classOverlay="search-bar"
          placeholder="Search by UPC, EAN, ISBN, Title, Brand"
          style={{ flex: 1, minWidth: '264px' }}
          onChange={({ target }) => handleSearchProduct(target?.value)}
        />
        {/* <Checkbox
          className=''
          checked={filters?.itemsFilter === 'viewAll' ? true : false}
          defaultChecked={false}
          onChange={handleItemsFilter}>
          Include Received
        </Checkbox> */}
      </div>

      <Spin tip='Loading...' spinning={fetchingWarehousePoDetails}>
        <AgGrid
          gridReady={gridReady}
          user_referrals={poWarehouseDetails}
          defaultColDef={defaultColDefNew}
          columnDefinitions={columnDefs}
          rowHeight={64}
          headerHeight={36}
          height='345px'
          masterDetail={true}
          detailRowAutoHeight={true}
          onSortChange={onSortChange}
          className='sku-table'
        />
      </Spin>
      <Pagination
        total={totalWarehousePoDetailsCount}
        totalPages={ceil(totalWarehousePoDetailsCount / pageSize + 1)}
        pageNumber={pageNumber}
        pageLimit={pageSize}
        handleLimitChange={(e) => handlePagination(e, 'pageSize')}
        handlePageNumberChange={(e) => handlePagination(e, 'pageNumber')}
        handlePageChangeLeft={(e) => handlePagination(e, 'pageNumber')}
        handlePageChangeRight={(e) => handlePagination(e, 'pageNumber')}
        refreshGridClick={refreshGridClick}
      />
      <Modal
        open={revertReceivingStatus}
        onClose={() => setRevertReceivingStatus(false)}
        onHide={() => setRevertReceivingStatus(false)}
        closeText="Cancel"
        saveText="Move Back"
        className="delete-confirmation-modal"
        closeButton={true}
        onSave={() => {
          handlePoUpdate('Receiving');
        }}
      >
        <PoWarehouseDetailsWrapper>
          <div className='delete-modal-wrapper'>
            <img src={Receiving} alt='Receiving' title='Receiving' />
            <h3>Move Back to Receiving</h3>
            <p>Are you sure you want to move this PO back to receiving status?</p>
          </div>
        </PoWarehouseDetailsWrapper>
      </Modal>

      <Modal
        open={bulkReceivingModal}
        onClose={() => setBulkReceivingModal(false)}
        onHide={() => setBulkReceivingModal(false)}
        closeText="Cancel"
        saveText="Yes"
        className="delete-confirmation-modal"
        closeButton={true}
        onSave={() => {
          handleBulkReceive();
        }}
        buttonDisabled={bulkReceivingLoading}
      >
        <PoWarehouseDetailsWrapper>
          <div className='delete-modal-wrapper'>
            <img src={Receiving} alt='Receiving' title='Receiving' />
            <h3>Bulk Receive</h3>
            <p>Are You Sure You Want To Bulk Receive All Po Items?</p>
          </div>
        </PoWarehouseDetailsWrapper>
      </Modal>

      <Modal
        open={isConfirm}
        onClose={() => setIsConfirm(false)}
        onHide={() => setIsConfirm(false)}
        closeText="Cancel"
        saveText="Confirm"
        header="Delete Confirmation"
        className="delete-confirmation-modal"
        closeButton={true}
        onSave={() => {
          handlePoUpdate('Processed');
        }}
      >
        <PoWarehouseDetailsWrapper>
          <div className='delete-modal-wrapper'>
            <img src={MarkAsResolved} alt='MarkAsResolved' title='MarkAsResolved' />
            <h3>Mark as Received</h3>
            <p>Are you sure you want to mark this as received?</p>
          </div>
        </PoWarehouseDetailsWrapper>
      </Modal>
      <ReceiveProductDrawer
        title='Receive Product'
        placement='right'
        onClose={closeDrawer}
        visible={isDrawerOpen}
        rowData={selectedData}
        po_status={po_status}
        filters={filters}
        poId={id}
      ></ReceiveProductDrawer>
    </PoWarehouseDetailsWrapper>
  );
};

export default PoWarehouseDetails;
